import request from '@/utils/request'

// 获取车场树
export function getCarParkTree(query) {
  return request({
    url: '/api/v3/park/tree',
    method: 'get',
    params: query
  })
}

// 删除车场/车场组
export function delCarPark(type, data) {
  return request({
    url: `/api/v3/park/delete/${type}`,
    method: 'delete',
    data
  })
}
// 新增车场
export function addCarPark(data) {
  return request({
    url: '/api/v3/park/create',
    method: 'post',
    data
  })
}
// 新增车场分组
export function addCarParkGroup(data) {
  return request({
    url: '/api/v3/park/group/create',
    method: 'post',
    data
  })
}
// 修改车场
export function updateCarPark(data) {
  return request({
    url: '/api/v3/park/update',
    method: 'put',
    data
  })
}
// 车场详情
export function getCarParkDetail(id) {
  return request({
    url: `/api/v3/park/detail/${id}`
  })
}
// 车场详情
export function getCarParkGroupDetail(id) {
  return request({
    url: `/api/v3/park/group/detail/${id}`
  })
}

// 修改车场分组
export function updateCarParkGroup(data) {
  return request({
    url: '/api/v3/park/group/update',
    method: 'put',
    data
  })
}
//* 车位列表
export function getCarSpotList(data) {
  return request({
    url: '/api/v3/park/spot/list',
    method: 'post',
    data
  })
}
//* 新增车位
export function createCarSpot(data) {
  return request({
    url: '/api/v3/park/spot/create',
    method: 'post',
    data
  })
}
//* 修改车位
export function updateCarSpot(data) {
  return request({
    url: '/api/v3/park/spot/update',
    method: 'put',
    data
  })
}
//* 修改车位
export function updateCarSpotBatch(data) {
  return request({
    url: '/api/v3/park/spot/update-batch',
    method: 'put',
    data
  })
}
//* *车位详情
export function getCarSpotDetail(id) {
  return request({
    url: `/api/v3/park/spot/detail/${id}`,
    method: 'post'
  })
}
//* *删除车位
export function deleteCarSpot(data) {
  return request({
    url: '/api/v3/park/spot/delete',
    method: 'delete',
    data
  })
}
//* *车位产权转移
export function transferCarSpot(data) {
  return request({
    url: '/api/v3/park/spot/transfer',
    method: 'put',
    data
  })
}

// 查询客户关联车位
export function getCustomerCarSpot(customerId) {
  return request({
    url: `/api/customer/park-spot/${customerId}`,
    method: 'GET'
  })
}
